import {
  QUIZ,
  QUIZ_SUCCESS,
  QUIZ_FAILURE,
  ATTEMPT_QUIZ,
  ATTEMPT_QUIZ_SUCCESS,
  ATTEMPT_QUIZ_FAILURE,
  SET_INDEX,
  RESET_INDEX,
  QUIZ_FINISHED,
  RESET_QUIZ,
  SET_POINTS
} from "./types"

const initialState = {
  error: false,
  quiz: false,
  index: 0,
  isFinished: false,
  quizRequesting: false,
  attemptQuizRequesting: false,
  result: false,
  totalPoints:0,
  quizStatus: "not completed"
}

export default (state = initialState, action) => {
  switch (action.type) {
    case QUIZ:
      return {
        ...state,
        quizRequesting: true
      }

    case QUIZ_SUCCESS:
      return {
        ...state,
        quizRequesting: false,
        quiz: action.data
      }

    case QUIZ_FAILURE:
      return {
        ...state,
        quizRequesting: false,
        error: action.error
      }

    case ATTEMPT_QUIZ:
      return {
        ...state,
        attemptQuizRequesting: true
      }

    case ATTEMPT_QUIZ_SUCCESS:
      return {
        ...state,
        attemptQuizRequesting: false,
        result: action.data
      }

    case ATTEMPT_QUIZ_FAILURE:
      return {
        ...state,
        attemptQuizRequesting: false,
        error: action.error
      }

    case SET_INDEX:
      console.log("action.data",action.data)
      return {
        ...state,
        index: action.data.index,
        isFinished: action.data.isFinished
        //   action.data - 1 === state.index ? action.data - 1 : state.index + 1,
        // isFinished: action.data - 1 === state.index ? true : false
      }

    case SET_POINTS:
      return {
        ...state,
        totalPoints: action.data
      }

    case RESET_INDEX:
      return {
        ...state,
        index: 0
      }

    case QUIZ_FINISHED:
      return {
        ...state,
        quizStatus: "completed"
      }
      
    case RESET_QUIZ:
      return initialState

    default:
      return state
  }
}
